export const SHORTCUT_VIEW_IDS = ["editor", "table", "calendar", "timelineV3"];

export const SHORTCUT_VIEW_LABELS = {
  editor: "Editor",
  table: "Table",
  calendar: "Calendar",
  timelineV3: "Timeline",
};

// Token values:
// - "mod" => ⌘ (macOS/iOS) / Ctrl (non-macOS)
// - "ctrl" => Ctrl
// - "alt" => ⌥ (macOS/iOS) / Alt (non-macOS)
// Each shortcut can define one or more key combinations in `combos`.
// Each combo renders as Kbd tokens joined with "+".
// Multiple combos are joined using `comboSeparator` ("or" by default).
export const GLOBAL_SHORTCUTS = [
  {
    combos: [["mod", "Z"]],
    description: "Undo",
  },
  {
    combos: [["mod", "Shift", "Z"]],
    description: "Redo",
  },
  {
    combos: [["mod", "A"]],
    description: "Select all visible photos",
  },
  {
    combos: [["Arrow Up"], ["Arrow Down"]],
    comboSeparator: "/",
    description: "Move photo selection in queue-based views",
  },
  {
    combos: [["Escape"]],
    description: "Clear selection",
  },
  {
    combos: [["alt", "Arrow Left/Right"]],
    description: "Cycle workspace views",
  },
  {
    combos: [["J"]],
    description: "Set Date Taken for targeted photos",
  },
  {
    combos: [["N"]],
    description: "Set Date Taken to now for targeted photos",
  },
  {
    combos: [["["], ["]"]],
    comboSeparator: "/",
    description: "Move targeted Date Taken by 1 minute",
  },
  {
    combos: [["Shift", "["], ["Shift", "]"]],
    comboSeparator: "/",
    description: "Move targeted Date Taken by 1 hour",
  },
  {
    combos: [["ctrl", "Shift", "["], ["ctrl", "Shift", "]"]],
    comboSeparator: "/",
    description: "Move targeted Date Taken by 1 day",
  },
  {
    combos: [["?"]],
    description: "Open keyboard shortcuts",
  },
  {
    combos: [["mod", "Shift", "L"], ["mod", "Shift", "G"]],
    description: "Open location picker",
  },
  {
    combos: [["mod", "Shift", "P"]],
    description: "Open presets",
  },
];

export const VIEW_SHORTCUTS = {
  editor: [
    {
      combos: [["Arrow Up"], ["Arrow Down"]],
      comboSeparator: "/",
      description: "Move photo selection when focus is outside an editor field",
    },
    {
      combos: [["Arrow keys"]],
      description: "Adjust or move between Date Taken spinner fields when focused",
    },
  ],
  table: [
    {
      combos: [["Arrow keys"]],
      description: "Navigate cells",
    },
    {
      combos: [["Shift", "Arrow"]],
      description: "Expand cell selection",
    },
    {
      combos: [["mod", "Arrow"]],
      description: "Jump to the first or last row/column",
    },
    {
      combos: [["mod", "C"]],
      description: "Copy selected cells",
    },
    {
      combos: [["mod", "V"]],
      description: "Paste into selected cells",
    },
    {
      combos: [["Delete"], ["Backspace"]],
      comboSeparator: "/",
      description: "Clear selected cell values",
    },
    {
      combos: [["Enter"]],
      description: "Edit focused cell",
    },
  ],
  calendar: [
    {
      combos: [["Shift", "J"]],
      description: "Navigate to previous month/week",
    },
    {
      combos: [["K"]],
      description: "Navigate to next month/week",
    },
  ],
  timelineV3: [
    {
      combos: [["Arrow Left"], ["Arrow Right"]],
      comboSeparator: "/",
      description: "Select previous/next photo in the current row",
    },
    {
      combos: [["Arrow Up"], ["Arrow Down"]],
      comboSeparator: "/",
      description: "Select previous/next populated time row",
    },
    {
      combos: [["mod", "Arrow Up"], ["mod", "Arrow Down"]],
      comboSeparator: "/",
      description: "Move time window earlier/later",
    },
    {
      combos: [["mod", "Shift", "Arrow Up"], ["mod", "Shift", "Arrow Down"]],
      comboSeparator: "/",
      description: "Jump time window earlier/later",
    },
    {
      combos: [["+"], ["-"]],
      comboSeparator: "/",
      description: "Zoom timeline specificity",
    },
    {
      combos: [["T"]],
      description: "Jump to today",
    },
    {
      combos: [["F"]],
      description: "Fit timeline to photos",
    },
    {
      combos: [["Delete"], ["Backspace"]],
      comboSeparator: "/",
      description: "Remove Date Taken from selected photos",
    },
    {
      combos: [["Enter"]],
      description: "Open selected photo in Editor",
    },
  ],
};
